module.exports = "\n<router-outlet></router-outlet>\n\n\n"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main